// extracted by mini-css-extract-plugin
export default {"History":"History_History__MNF5e","HistoryBG":"History_HistoryBG__hRd69","Wrapper":"History_Wrapper__nGBRl"};